/* global __CLIENT__*/
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { List } from 'immutable';

import { ModalActions } from '../../actions/modal';
import immutableCreatorSelector from '../../selectors/immutableCreatorSelector';
import {
  currentProjectIdSelector,
} from '../../reducers/projects';
import {
  currentUserSelector,
  userModeSelector,
  getUserModeByProjectId,
} from '../../reducers/users';

import NotAuthorized from '../NotAuthorized';
import CreateElementModal from './CreateElementModal';
import CreateElementNewModal from './CreateElementNewModal';
// import CreateProjectModal from './CreateProjectModal';
// import CreateCustomPropertyModal from './CreateCustomPropertyModal';
import CreateElementTypePropertyModal from './CreateElementTypePropertyModal';
import CreateElementTypeModal from './CreateElementTypeModal';
import RenameElementTypePropertyModal from './RenameElementTypePropertyModal';
import RenameElementTypeMetaPropertyModal
  from './RenameElementTypeMetaPropertyModal';
// import AddElementTypeMetaPropertyModal from './AddElementTypeMetaPropertyModal';
import DeleteConfirmationModal from './DeleteConfirmationModal';
import CreateRelationshipTypePropertyModal
  from './CreateRelationshipTypePropertyModal';
import CreateRelationshipTypeModal from './CreateRelationshipTypeModal';
import RenameRelationshipTypePropertyModal
  from './RenameRelationshipTypePropertyModal';
import RenameRelationshipTypeMetaPropertyModal
  from './RenameRelationshipTypeMetaPropertyModal';
// import AddRelationshipTypeMetaPropertyModal from './AddRelationshipTypeMetaPropertyModal';
import IconSelectModal from './IconSelectModal';
import CreateProjectPropertyModal from './CreateProjectPropertyModal';
import RenameProjectPropertyModal from './RenameProjectPropertyModal';
// import RenameElementCustomPropertyModal from './RenameElementCustomPropertyModal';
import AddProjectUserModal from './AddProjectUserModal';
import EditTypePropertyModal from './EditTypePropertyModal';
import CreateBaseLineModal from './CreateBaseLineModal';
import CreateDailyTaskCompleteReportModal
  from './CreateDailyTaskCompleteReportModal';
import RenameOrganizationModal from './RenameOrganizationModal';
import RenameAccountModal from './RenameAccountModal';
import '../../styles/FullScreenModal.css';

class FullScreenModal extends PureComponent {
  static propTypes = {
    hideModal: PropTypes.func,
    backModal: PropTypes.func,
    showBackButton: PropTypes.bool,
  }

  constructor() {
    super();
    this.onBack = this.onBack.bind(this);
    this.onClose = this.onClose.bind(this);
  }

  onClose() {
    this.props.hideModal();
  }

  onBack() {
    this.props.backModal();
  }

  render() {
    const { modal } = this.props;

    const display = this.props.showModal ? 'flex' : 'none';
    const displayBackButton = this.props.showBackButton ? 'back-button' : 'hide';

    const style = ['fs-modal-container'];

    if (modal) {
      switch (modal.get('name')) {
        case 'IconSelectModal':
        case 'CreateElementNewModal':
        // case 'AddRelationshipModal':
          style.push('iconselect-select-modal-override');
          break;
        default:
          break;
      }
    }

    let combinedStyle = style.join(' ');

    return (
      <div style={{ display }} className="modal-wrapper">
        <div className={combinedStyle}>
          <div className="fs-modal-close">
            <div onClick={this.onBack} className={displayBackButton}>
              <i className="fa fa-arrow-left fa-2x" />
            </div>
            <div onClick={this.onClose} className="modal-close-btn">
              <i className="fa fa fa-times fa-2x" />
            </div>
          </div>
          {this.props.children}
        </div>
      </div>
    );
  }
}

const modalsSelector = (state) => state.modal.get('modals');
const fullScreenModalSelector = immutableCreatorSelector(
  [
    modalsSelector,
    currentProjectIdSelector,
    currentUserSelector,
    userModeSelector,
  ],
  (
    modals,
    currentProjectId,
    user,
  ) => ({
    modals,
    currentProjectId,
    user,
    userMode: getUserModeByProjectId(user, currentProjectId),
  })
);

// @connect(state => ({
//   modals: state.modal.get('modals'),
// }))
@connect(fullScreenModalSelector)
export default class FullScreenContainer extends PureComponent {
  static propTypes = {
    modals: PropTypes.instanceOf(List),
    dispatch: PropTypes.func,
  };

  modalLookup = modal => {
    const { userMode } = this.props;
    const readerMode = (userMode === 'reader');
    const modals = {
      NotAuthorized,
      CreateElementModal,
      CreateElementNewModal,
      DeleteConfirmationModal,
      // CreateCustomPropertyModal,
      CreateElementTypePropertyModal,
      CreateElementTypeModal,
      RenameElementTypePropertyModal,
      RenameElementTypeMetaPropertyModal,
      // AddElementTypeMetaPropertyModal,
      CreateRelationshipTypePropertyModal,
      CreateRelationshipTypeModal,
      RenameRelationshipTypePropertyModal,
      RenameRelationshipTypeMetaPropertyModal,
      // AddRelationshipTypeMetaPropertyModal,
      CreateProjectPropertyModal,
      IconSelectModal,
      RenameProjectPropertyModal,
      // RenameElementCustomPropertyModal,
      AddProjectUserModal,
      EditTypePropertyModal,
      CreateBaseLineModal,
      CreateDailyTaskCompleteReportModal,
      RenameOrganizationModal,
      RenameAccountModal,
    };

    if (readerMode) {
      return modals.NotAuthorized;
    }

    if (modal) {
      const modalName = modal.get('name');

      if (modals[modalName]) {
        return modals[modalName];
      }
    }

    return undefined;
  };

  render() {
    const { dispatch, modals, routeParams, params } = this.props;
    const modal = modals.last();
    const Modal = this.modalLookup(modal) || 'div';
    const showModal = (modals.size > 0);
    const showBackButton = (modals.size > 1);
    const renderModal = this.modalLookup(modal)
      ? <Modal routeParams={routeParams} params={params} />
      : <div />;

    return (
      <FullScreenModal
        modal={modal}
        showModal={showModal}
        showBackButton={showBackButton}
        routeParams={routeParams}
        {...bindActionCreators(ModalActions, dispatch)}
      >
        {renderModal}
      </FullScreenModal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/modals/FullScreenModal.js